import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from "@angular/forms";

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
})
export class TextAreaComponent  implements OnInit {

  @Input() label: string;
  @Input() control: FormControl;
  @Input() placeholder: string;
  @Input() minRows: number = 5;

  constructor() { }

  ngOnInit() {}

}
